export default {
    'searchList': {
        'searchTxt': [{
            'name': '起运地',
            'value': 'starAdder',
            'filterable': true,
            'unfold': true,
            'config': {
                'checkStrictly': true
            },
            'type': 'addressSelect',
            'span': 3
        }, {
            'name': '目的地',
            'value': 'endAdder',
            'filterable': true,
            'unfold': true,
            'config': {
                'checkStrictly': true
            },
            'type': 'addressSelect',
            'span': 3
        }, {
            'name': '发布时间',
            'value': 'createTime',
            'startTime': 'beginDate',
            'endTime': 'endDate',
            'startPlaceholder': '发布开始日期',
            'endPlaceholder': '发布结束日期',
            'type': 'time',
            'unfold': true,
            'span': 7
        }, {
            'name': '客户',
            'value': 'dispatchNo',
            'type': 'input',
            'unfold': false,
            'span': 3
        }, {
            'name': '创建时间',
            'value': 'issueTime',
            'startTime': 'beginDate',
            'endTime': 'endDate',
            'startPlaceholder': '创建开始日期',
            'endPlaceholder': '创建结束日期',
            'type': 'time',
            'unfold': false,
            'span': 7
        }],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'columns': [
            {
                'label': '统计日期',
                'prop': 'dispatchNo',
                'width': '148px'
            },
            {
                'label': '分公司',
                'prop': 'siteName',
                'width': '100px'
            },
            {
                'label': '服务平台',
                'prop': 'senderProvinceName',
                'width': '86px'
            },
            {
                'label': '客户',
                'prop': 'senderCityName',
                'width': '86px'
            },
            {
                'label': '起运地',
                'prop': 'senderDistrictName',
                'width': '86px'
            },
            {
                'label': '目的地',
                'prop': 'receiverProvinceName',
                'width': '86px'
            },
            {
                'label': '发运任务量(体积)',
                'prop': 'receiverCityName',
                'width': '88px'
            },
            {
                'label': '发运任务目标',
                'prop': 'receiverDistrictName',
                'width': '86px'
            },
            {
                'label': '承运商运力反馈',
                'prop': 'driver',
                'width': '70px'
            },
            {
                'label': '当日实际到车量',
                'prop': 'driverContactWay',
                'width': '102px'
            },
            {
                'label': '当日实际发车量',
                'prop': 'vehicleCard',
                'width': '82px'
            },
            {
                'label': '发布时间',
                'prop': 'allFreight'
            }],
        'action': [
            {
                'type': 'text',
                'label': '编辑',
                'size': 'mini',
                'event': 'edit'
            }
        ],
        'leftOperation': true
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100] // eslint-disable-line
    }
};
